const type = 'SET_CUSTOMER_PHONES_HISTORY_ERROR';

const setCustomerPhonesHistoryError = (data = {}) => ({
  data,
  type,
});

export default setCustomerPhonesHistoryError;
